export enum FeeCoverageCalcTypeEnum {
  ValidValue = 'FC7288B7-AA19-4026-9B54-8BE71DBC7EF4',
  Percent = '00000048-1000-0000-0000-000000000001',
  Money = '00000048-1000-0000-0000-000000000002'
}

